import gql from 'graphql-tag';

export default gql`query getAllThreadItems($threadId: Int!, $lastId: Int, $newestId:Int, $offset: Int){
  getAllThreadItems(threadId:$threadId, lastId: $lastId, newestId:$newestId, offset: $offset){              
          id
          content
          sentBy
          isRead
          eventName
          createdAt
      }
  }
`;



// WEBPACK FOOTER //
// ./src/mobxStores/Inbox/getThreadItemsQ.js